<div>
  <ul class="sorting">
    <li value="asc" (click)="onClick($event, 'asc')"><i class="{{ascClass}}"></i><label>{{ "sort.asc" | translate }}</label></li>
    <li value="desc" (click)="onClick($event, 'desc')"><i class="{{dscClass}}"></i><label>{{ "sort.desc" | translate }}</label></li>
    <!-- <li value="reset" (click)="onClick($event, 'reset')"><img src="/assets/images/reset.png"
        style="width: 12px;" /><label>Reset</label></li> -->
  </ul>
  <div class="separator"></div>
</div>